<template>
  <slider-levels />

  <the-nav />

  <div class="main-wrap">
    <div class="levels-wrap">
      <div class="levels-head">
        <div class="levels-banner blik">
          <img src="/images/levels-banner1.webp" alt="" class="levels-banner1" />
          <img src="/images/levels-banner2.webp" alt="" class="levels-banner2" />
        </div>
        <div class="levels-present blik2">
          <span class="levels-present-title">При достижении уровня<br />Супер VIP дарим:</span>
          <img src="/images/present1.webp" alt="" class="present1" />
          <span class="levels-present-name"><img src="/images/apple.svg" alt="" />MacBook Pro</span>
        </div>
        <div class="levels-present blik2">
          <span class="levels-present-title">При достижении уровня<br />Легендарный дарим:</span>
          <img src="/images/present2.webp" alt="" class="present2" />
          <span class="levels-present-name"><img src="/images/apple.svg" alt="" />iPhone</span>
        </div>
      </div>

      <div class="levels-content">
        <div class="faq-title">Уровни игрового клуба Миллионъ</div>
        <div class="levels-line">
          <swiper
            :slides-per-view="1"
            :modules="modules"
            :navigation="{ nextEl: '.levels-line-next', prevEl: '.levels-line-prev' }"
            :breakpoints="{
              '350': {
                slidesPerView: 1,
              },
              '500': {
                slidesPerView: 2,
              },
              '750': {
                slidesPerView: 3,
              },
              '900': {
                slidesPerView: 3,
              },
              '1070': {
                slidesPerView: 4,
              },
              '1350': {
                slidesPerView: 5,
              },
            }"
          >
            <swiper-slide v-for="n in 6" :key="n">
              <LevelDescription v-bind="levels[n - 1]" :active="currentUser?.status?.cur_level === n" />
            </swiper-slide>

            <swiper-slide>
              <div class="level-item-wrap">
                <div :class="`level-item mnthy ${this.showVip ? 'active' : ''}`">
                  <div class="level-item-image"><UserLevelImg :level="this.curVip" /></div>

                  <div class="lit-drop">
                    <div class="lit-drop-title" @click="this.showVip = !this.showVip"></div>
                    <div class="lit-drop-title-hidden" v-if="this.showVip" @click="this.showVip = false">
                      <div class="lit-item" v-for="n in 11" @click="this.curVip = 6 + n" :key="n">
                        VIP {{ n - 1 || '' }}
                      </div>
                    </div>
                  </div>

                  <div class="level-item-info">
                    <LevelDescription v-bind="levels[this.curVip - 1]" short />
                  </div>
                </div>
              </div>
            </swiper-slide>

            <swiper-slide v-for="n in 5" :key="n">
              <LevelDescription v-bind="levels[17 + n - 1]" :active="currentUser?.status?.cur_level === 17 + n" />
            </swiper-slide>
          </swiper>
          <div class="footer-slider-nav">
            <div class="levels-line-prev slider-arrow" />
            <div class="levels-line-next slider-arrow slider-arrow-right" />
          </div>
        </div>

        <div class="levels-descr">
          В игровом клубе Миллионъ существует уникальная система уровней, которая позволяет получать преимущетсва
          постоянным игрокам. Проделайте путь от Новичка до Миллионера делая ставки в игровых автоматах и получая за это
          баллы. 1 балл = 500 ₽. С каждым новым уровнем Вы получаете бонусы, фриспины и увеличиваете свой кэшбек. Вот
          что Вы можете получить достигая новых уровней:
          <br /><br />
          • Бонус за повышение уровня до 1 000 000 ₽
          <br /><br />
          • Увеличенный кэшбек до 50%
          <br /><br />
          • Щедрые подарки : iPhone и MacBook Pro
          <br /><br />
          • Бездепозитные FS и премиум бонусы
          <br /><br />
          • Личный менеджер и многое другое
          <br /><br />
          <span style="color: #eebd11"
            >* Начиная с уровня "Золотой" сумму бонуса необходимо отыгрывать c 10x вейджером, а с уровня "Платиновый"
            вейджер составит x20. Максимальная сумма выигрыша равна сумме бонуса.</span
          >
        </div>
      </div>

      <div class="faq-fl">
        <div class="faq-title">Частые вопросы и ответы</div>
        <div class="faq-cols">
          <div
            :class="`faq-item ${this.show === elem.id ? 'faq-item-show' : ''}`"
            v-for="elem in FAQ_LC"
            :key="elem.id"
            @click="this.show === elem.id ? (this.show = null) : (this.show = elem.id)"
          >
            <div class="faq-item-title">{{ elem.title }}</div>
            <div class="faq-item-text" v-if="this.show === elem.id" v-html="elem.text" />
          </div>
        </div>
        <div class="faq-cols">
          <div
            :class="`faq-item ${this.show === elem.id ? 'faq-item-show' : ''}`"
            v-for="elem in FAQ_RC"
            :key="elem.id"
            @click="this.show === elem.id ? (this.show = null) : (this.show = elem.id)"
          >
            <div class="faq-item-title">{{ elem.title }}</div>
            <div class="faq-item-text" v-if="this.show === elem.id" v-html="elem.text" />
          </div>
        </div>
      </div>
    </div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation } from 'swiper/modules'
import PlayLine from '@/components/PlayLine'
import SliderLevels from '@/components/sliders/SliderLevels'
import TheNav from '@/components/TheNav'
import BonusesLine from '@/components/BonusesLine.vue'
import UserLevelImg from '@/components/UserLevelImg.vue'
import LevelDescription from '@/components/levels/LevelDescription.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Levels',
  components: {
    LevelDescription,
    UserLevelImg,
    Swiper,
    SwiperSlide,
    BonusesLine,
    TheNav,
    PlayLine,
    SliderLevels,
  },
  computed: {
    ...mapGetters(['currentUser', 'levels']),
  },
  setup() {
    const { t } = useI18n()

    return {
      FAQ_LC,
      FAQ_RC,
      modules: [Navigation],
      t,
    }
  },
  data() {
    return {
      show: null,
      showTooltip: false,
      showVip: false,
      curVip: 7,
    }
  },
}

const FAQ_LC = [
  {
    id: 0,
    title: 'Какие преимущества мне дает уровень?',
    text: 'При достижении уровня Вам моментально предоставляется бонус (его нужно активировать во вкладке Бонусы), который положен при переходе на этот уровень. Сумму зачисления Вы можете посмотреть в колонке «Бонус». Так же, при каждом увеличении уровня у Вас увеличивается % кэшбеке для бонуса «Возврат», о котором вы можете прочесть ниже.',
  },
  {
    id: 1,
    title: 'Как получить +100% на первый и +150% на второй депозит?',
    text: 'Для получения привественного бонуса, Вам нужно совершить депозит и перейти во вкладку «Бонусы» в кассе и активируйте соответсвующий бонус нажав кнопку "Активировать" и активировать Ваш номер телефона - бонус будет зачислен. С более подробной информацией по активации приветсвенного бонуса Вы сможете ознакомиться на странице <a href="/bonuses">"Бонусы"</a>.',
  },
  {
    id: 2,
    title: 'Что нужно для того чтобы получить следующий уровень?',
    text: 'Для получения уровней Вам не нужно делать ничего лишнего. Просто играйте и получайте удовольствие от игры в автоматы. Делая ставки в автоматах, Вы зарабатываете баллы. Чтобы заработать 1 балл необходимо сделать ставок на сумму 500 ₽. Сколько Вам осталось до достижения следующего уровня Вы можете увидеть по строке статуса, которая находится в кассе и на полосе меню. Баллы зачисляются только при ставках в игровых автоматах. Ставки в рулетках в рост уровня учтены не будут.',
  },
  {
    id: 3,
    title: 'Что такое вейджер х10 или х20?',
    text: 'Вейджер х10 или х20 - это условия для возможности снятия зачисленных бонусных средств. Для того чтобы снять бонус в размере 1500 рублей с вейджером х10, вам нужно сделать ставок на 15 000 рублей и после даного выполнения условия вейджера бонус станет Вам доступным для снятия. Все средства, которые были у вас на счету до зачисления бонуса Вы можете беспрепятственно вывести на любую доступную платежную систему. А все выигранные средства после зачисления бонус с вейджером и сумму бонуса, которая зачислена с вейджером Вам нужно отьиграть, сделав сумму ставок, требующую вейджером. И после отьигрыша вывести на свой счет. Пример. У Вас на счету 1000 рублей. Вы получили золотой уровень и получили на счет 1500 рублей. После этого играли и выиграли еще 2000 рублей. До того момента как вы не выполнили условия вейджера Х10 и не сделали ставок на сумму 15000 рублей - Вы можете вывести только 1000 рублей, которые были на счету до зачисления бонуса. Всю сумму, которая выше 1000 рублей, можете вывести только после выполнения условия вейджера.',
  },
  {
    id: 4,
    title: 'Как я пойму, что у меня повысился уровень статуса?',
    text: 'Сразу при достижении статуса Вы получите всплывающее сообщение об этом, а также во вкладке Бонусы Вам будет доступ бонус для активации.',
  },
  {
    id: 5,
    title: 'Что такое «Возврат»?',
    text: 'Возврат или кэшбек - уникальный бонус, который позволяет вернуть Вам средства в случае проигрыша. Бонус начисляется игрокам в виде процентов от проигранной игроками суммы реальными деньгами (см. таблицу), что дает всем игрокам отличный шанс отыграть свои деньги.',
  },
  {
    id: 13,
    title: 'Что такое «Бездепозитные FS»?',
    text: 'Начиная с уровня Золотой все игроки могут получать бездепозитные фриспины во время их раздачи которая анонсируется по почте или в нашем <a href="https://t.me/millionb_club">"Телеграм канале"</a>.',
  },
]
const FAQ_RC = [
  {
    id: 6,
    title: 'Как рассчитывается бонус «Возврат»?',
    text: 'Бонус рассчитывается с момента последнего зачисления бонуса, если таковой был или же с первого Вашего пополнения. Давайте рассмотрим в примере: У Вас уровень супер VIP (процент возврата составляет 50%). Вы пополнили на 1000 рублей и проиграли. Вы можете сразу вернуть на счет 500 рублей моментально и продолжить играть на них или же вывести. На данный момент сумма возврата составляет 0, т.к. вы ничего не пополняли после получение бонуса. Сумма зачисленного бонуса не считается в сумму возврата. Даже если Вы снимете 500 рублей и пополните обратно, то сумма возврата останется неизменной - 0. С 500 рублей Вы выигрываете 5000 рублей и снимаете их. Через пару дней пополняете на 2000 рублей и проигрываете, смотрите на сумму возврата, а она остается неизменной, до сих пор 0. Возникает вопрос: «почему?». Здесь вступает правило «Бонус рассчитывается с момента последнего зачисления бонуса», то есть с момента последнего зачисления бонуса Вы остаетесь в выигрыше у заведения. Фактически – Вы ничего не проиграли, т.к. перед этим вывели сумму больше, чем пополнили после. Когда Вы снова заведете сумму больше, чем вывели с момента зачисления последнего бонуса – бонус «возврат средств» снова начнет рассчитываться.',
  },
  {
    id: 7,
    title: 'Где я могу увидеть сумму, которую я могу вернуть?',
    text: 'В кассе, справа в углу под словом Возврат, а также при игре в автомат слева будет показано сколько Вы можете вернуть средств.',
  },
  {
    id: 8,
    title: 'Что нужно, чтобы получить бонус «Возврат»?',
    text: 'Обязательным условием получение бонуса «Возврат» является сумма на Вашем счету – она должна быть меньше 1 рубля.',
  },
  {
    id: 9,
    title: 'В кассе мне указывает 0 в графе «Возврат»?',
    text: 'Если у Вас в графе Возврат показывает 0, то Вы выигрываете у заведения с момента зачисления последнего бонуса, или же на данный момент у Вас уровень «новичок», в котором процент возврата средств не предусмотрен и Вам нужно повысить уровень.',
  },
  {
    id: 10,
    title: 'Что такое "Лимит вывода"?',
    text: 'На сайте действует ограничение на снятие со счета в сутки, в зависимости от вашего уровня от 10 000 ₽ и до без ограничений. Суммы свыше лимита обговариваются индивидуально с администрацией.',
  },
  {
    id: 11,
    title: 'Что делать когда достиг уровня с призами MacBook или iPhone?',
    text: 'Поздравляем, если Вы достигли уровня Супер VIP или Легендарный. Для получения бонуса обратитесь в службу поддержки онлайн для дальнейшей инструкции получения Iphone или Macbook. Для уровня Супер VIP - подарок iPhone последней модели на 128 GB или эквивалент суммы стоимости товара по курсу центрального банка РФ на момент зачисления может быть зачислена Вам на счет без вейджера. Цвет модели можете выбрать самостоятельно. Для уровня Легендарный - подарок Macbook PRO 14” последней модели на 512 GB или эквивалент суммы стоимости товара по курсу центрального банка РФ на момент зачисления или эквивалент суммы стоимости товара может быть зачислена Вам на счет без вейджера. Цвет модели можете выбрать самостоятельно.',
  },
  {
    id: 12,
    title: 'Что такое Премиум бонусы и личный менеджер?',
    text: 'Начиная с уровня Супер VIP  за Вами закрепляется личный менеджер, который помагает решать Ваши вопросы. А начиная с уровня Премиум личный менеджер может предоставлять Вам премиаульные бонусы не доступные в предыдущих уровнях.',
  },
]
</script>

<style scoped></style>
